import { LogoUpload } from "@/components/companies/LogoUpload";
import { useLanguage } from "@/contexts/LanguageContext";

interface LogoSectionProps {
  logoPreview: string;
  onLogoChange: (file: File) => void;
  onDrop: (file: File) => void;
  onRemove: () => void;
}

export const LogoSection = ({ logoPreview, onLogoChange, onDrop, onRemove }: LogoSectionProps) => {
  const { t } = useLanguage();

  return (
    <div className="col-span-12 lg:col-span-4">
      <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800 mb-6">{t("companyForm.logo.label")}</h2>
        <LogoUpload logoPreview={logoPreview} onLogoChange={onLogoChange} onDrop={onDrop} onRemove={onRemove} />
      </div>
    </div>
  );
};
